import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  modal: {
    position: 'absolute',
    top: '35%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100vw',
    padding: '14px',
  },
  modalButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: spacing(16),
  },
  modalContent: {
    width: 600,
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    color: Theme.Colors.Grayscale.SixtyFour,
    fontSize: Theme.Typography.FontSize.XXSmall,
    fontWeight: Theme.Typography.FontWeight.Small,
    lineHeight: '20px',
  },
  helperText: {
    marginTop: spacing(6),
    fontSize: Theme.Typography.FontSize.Tiny,
  },
  input: {
    marginTop: spacing(12),
  },
}))
